import { useState, useEffect, useCallback } from "react";
import i18n, { use } from "i18next";
import useAuth from "./hooks/useAuth";
import whiteList from "./data/whiteList";
import { useSnapshot } from "valtio";
import store from "./appStore";

// returns the current hash location in a normalized form
// (excluding the leading '#' symbol and language parameter)
export const currentLocation = () => {
  var currentLocation = window.location.hash;

  if (!currentLocation) {
    currentLocation = "/";
  }

  if (store.languages.length == 0) return currentLocation;

  store.languages.forEach((lang) => {
    currentLocation = currentLocation.replace(`#/${lang.locale}`, "");
  });

  if (!currentLocation) {
    currentLocation = "/";
  }

  return currentLocation;
};

const useHashLocation = () => {
  const [loc, setLoc] = useState(currentLocation());

  const navigate = (to) => {
    // if (!whiteList.some((wl) => to.endsWith(wl)) && to != "" && store.currentUser == null && !store.multiuser.spectating) {
    //   navigate(`${to}/cta`);
    //   return;
    // }

    setLoc(to);

    //HOTFIX so the hash will not be set too often
    if (window.location.hash == `#/${i18n.language}${to}` || !store.datastoreReady) return;
    window.location.hash = `/${i18n.language}${to}`;
  };

  useEffect(() => {
    // this function is called whenever the hash changes
    const handler = () => navigate(currentLocation());

    // subscribe to hash changes
    window.addEventListener("hashchange", handler);

    return () => window.removeEventListener("hashchange", handler);
  }, []);

  return [loc, navigate];
};

export default useHashLocation;
